import React from 'react';
import { Form, Input, Checkbox, Row, Col, Table, Space, Button, Select } from 'antd';

const { Option } = Select;

const AddCategory = ({ havingReference, reference, refData, onCancel, onSave }) => {
  const [form] = Form.useForm();

  const columns = [
    {
      dataIndex: 'status',
      key: 'status',
      width: '90px',
      render: (_, record) => {
        return (
          <Form.Item
            name="status"
            style={{
              margin: 0,
            }}
            label="Enable"
            valuePropName="checked"
          >
            <Checkbox />
          </Form.Item>
        );
      },
    },
    {
      dataIndex: 'name',
      key: 'name',
      render: (_, record) => {
        return (
          <Form.Item
            name="name"
            style={{
              margin: 0,
            }}
            rules={[
              {
                required: true,
                message: `Please Input Name!`,
              },
            ]}
          >
            <Input placeholder="Name" />
          </Form.Item>
        );
      },
    },
    {
      dataIndex: 'reference',
      key: 'reference',
      width: '200px',
      render: (_, record) => {
        return (
          <Form.Item
            name="reference"
            style={{
              margin: 0,
            }}
            rules={[
              {
                required: true,
                message: `Please select ${reference && reference.title}`,
              },
            ]}
          >
            <Select>
              {refData &&
                refData.map((category) => (
                  <Option value={category.id}>{category.name}</Option>
                ))}
            </Select>
          </Form.Item>
        );
      },
    },
    {
      dataIndex: 'code',
      key: 'code',
      width: '100px',
      render: (_, record) => {
        return (
          <Form.Item
            name="code"
            style={{
              margin: 0,
            }}
            rules={[
              {
                required: true,
                message: `Please Input Code!`,
              },
            ]}
          >
            <Input placeholder="Code" />
          </Form.Item>
        );
      },
    },
    {
      dataIndex: 'action',
      key: 'action',
      width: '150px',
      render: (_, record) => {
        return (
          <Space>            
            <Button type="primary" htmlType="submit">
              Save
            </Button>
            <Button onClick={onCancel} type="secondary">
              Cancel
            </Button>
          </Space>
        );
      },
    },
  ];

  const columns2 = columns.filter(column => (column.key !== 'reference' || havingReference));

  const dataSource = [
    {
      status: 1,
      name: '',
      code: '',
      reference: '',
    },
  ];

  return (
    <Form
      form={form}
      onFinish={(values) => onSave(values)}
      initialValues={{ status: true }}
    >
      <Row>
        <Col xs={24} style={{ textAlign: 'right', marginBottom: '.5rem' }}>
          <Table
            size="small"
            bordered
            showHeader={false}
            pagination={false}
            columns={columns2}
            dataSource={dataSource}
          />
        </Col>
      </Row>
    </Form>
  );
};

export default AddCategory;
